import { Form } from 'factorial-form'
import { computed, makeObservable } from 'mobx'

import i18n from 'modules/core/lib/i18n'

export interface CallRequestValues {
  phone: string
  scheduled_call: string
  request_call: Date
  email: string
  marketing_lead_form_campaign: string
  hs_lead_status: string
  lead_birthplace: string
  lead_origin: string
}

export interface CallFormValues {
  phone: string | null
}

export interface BookingFormValues {
  phone: string | null
  date: Date | null
  time: string | null
}

export default function validateNumberInput(value: string) {
  if (!!value.match(/^\+?\d+$/) && value !== '') {
    return
  }
  return i18n.t('pricing_plans.help_info.callpage_modal.phone_validation')
}

export class CallRequestForm extends Form {
  constructor(values: CallFormValues) {
    super(values, {
      phone: 'string',
    })

    makeObservable(this, {
      isValid: computed,
    })
  }

  get isValid(): boolean {
    return !validateNumberInput(this.get('phone').value)
  }
}

export class BookingRequestForm extends Form {
  constructor(values: BookingFormValues) {
    super(values, {
      phone: 'string',
      date: 'date',
      time: 'string',
    })

    makeObservable(this, {
      isValid: computed,
    })
  }

  get isValid(): boolean {
    if (
      !validateNumberInput(this.get('phone').value) &&
      this.get('date').value !== '' &&
      this.get('time').value !== ''
    )
      return true
    return false
  }
}
